module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-514.23c5a4a.woff2";